import { HtmlId } from '../enum';
import { Accordion, createAccordion } from '@vfde-brix/ws10/accordion';
import { mountComponent } from '../util/mount';
import { trackAccordion } from '../tracking/tracking';

/**
 * Create Brix Accordion component.
 * @param {string} wrapperId - ID of the accordion element
 */
export const mountAccordion = (wrapperId: HtmlId) =>
    mountComponent(wrapperId, createAccordion, {
        onToggle: ( item ) => {
            if (item.optOpen) {
                trackAccordion(item.stdHeadline);
            }
        },
    });

/**
 * Closes all items inside an accordion
 * @param {Accordion} comp - accordion to update
 */
export const closeAccordion = (comp: Accordion) => {
    const { items } = comp.getProperties();

    for (const item of items) {
        item.optOpen = false;
    }

    comp.update({ items });
};
